import _define_property from "@swc/helpers/src/_define_property.mjs";
import { scales, variants } from "./types";
var _obj;
export var scaleVariants = (_obj = {}, _define_property(_obj, scales.MD, {
    height: "40px",
    padding: "0 24px"
}), _define_property(_obj, scales.SM, {
    height: "32px",
    padding: "0 16px"
}), _define_property(_obj, scales.XS, {
    height: "20px",
    fontSize: "12px",
    padding: "0 8px"
}), _obj);
var _obj1;
export var styleVariants = (_obj1 = {}, _define_property(_obj1, variants.PRIMARY, {
    backgroundColor: "primary",
    color: "textMain",
    ":not(:disabled):hover": {
        backgroundColor: "primaryAlpha"
    }
}), _define_property(_obj1, variants.SECONDARY, {
    backgroundColor: "transparent",
    border: "1px solid",
    borderColor: "white10",
    boxShadow: "none",
    color: "white",
    ":disabled": {
        backgroundColor: "transparent"
    },
    ":not(:disabled):hover": {
        borderColor: "primary",
        color: "primary"
    }
}), _define_property(_obj1, variants.TERTIARY, {
    backgroundColor: "tertiary",
    boxShadow: "none",
    color: "primary",
    ":not(:disabled):hover": {
        opacity: 0.65
    }
}), _define_property(_obj1, variants.CONTAINED, {
    backgroundColor: "#ffffff80",
    boxShadow: "none",
    color: "primary",
    ":not(:disabled):hover": {
        opacity: 0.65
    }
}), _define_property(_obj1, variants.SUBTLE, {
    backgroundColor: "textSubtle",
    color: "backgroundAlt",
    ":not(:disabled):hover": {
        opacity: 0.65
    }
}), _define_property(_obj1, variants.DANGER, {
    backgroundColor: "failure",
    color: "white",
    ":not(:disabled):hover": {
        backgroundColor: "dangerAlpha"
    }
}), _define_property(_obj1, variants.SUCCESS, {
    backgroundColor: "success",
    color: "textMain",
    ":not(:disabled):hover": {
        backgroundColor: "successAlpha"
    }
}), _define_property(_obj1, variants.TEXT, {
    backgroundColor: "transparent",
    color: "primary",
    boxShadow: "none",
    ":not(:disabled):hover": {
        opacity: 0.65
    }
}), _define_property(_obj1, variants.LIGHT, {
    backgroundColor: "input",
    color: "textSubtle",
    boxShadow: "none",
    ":not(:disabled):hover": {
        opacity: 0.65
    }
}), _obj1);
